import { getToken as getTokenFromLocalStorage } from '../utils';

export const loggedIn = (state) =>
  state.auth.get('loggedIn') && !!getTokenFromLocalStorage();
export const isLoginInProgress = (state) => state.auth.get('loginSent');
export const getToken = () => getTokenFromLocalStorage();
export const shouldRememberUser = (state) => state.auth.get('rememberMe');
export const getAuthErrorMessage = (state) => state.auth.get('error');
